import { useState } from "react";
import { Copy, Check, Lock } from "lucide-react";
import { toast } from "sonner";

export function MaskedField({ label, value, mono = true, copyValue, testid }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(copyValue ?? value);
    setCopied(true);
    toast.success("Copied to clipboard");
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="flex flex-col gap-1.5" data-testid={testid}>
      {label && (
        <span className="text-xs font-mono uppercase tracking-wider text-muted-foreground">
          {label}
        </span>
      )}
      <div className="flex items-center justify-between gap-3 rounded-md border border-border bg-muted/40 px-3 py-2.5">
        <div className="flex items-center gap-2 min-w-0">
          <Lock className="h-3.5 w-3.5 shrink-0 text-primary" />
          <span className={`truncate text-sm ${mono ? "font-mono masked-dots" : ""}`}>
            {value || "—"}
          </span>
        </div>
        {copyValue && (
          <button
            onClick={handleCopy}
            data-testid={testid ? `${testid}-copy` : "copy-btn"}
            className="shrink-0 rounded-md p-1.5 text-muted-foreground transition-colors hover:bg-accent/20 hover:text-foreground"
          >
            {copied ? <Check className="h-4 w-4 text-primary" /> : <Copy className="h-4 w-4" />}
          </button>
        )}
      </div>
    </div>
  );
}
